import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import {
  StorageService,
  TOKEN_KEY,
} from '../../modules/auth/services/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private jwtHelperService: JwtHelperService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.getToken();

    if (token && this.isJWTValid() && !this.isJWTExpired()) {
      // Add Authorization header with the JWT token
      request = this.addAuthorizationHeader(request, token);
    }

    // Continue with the modified or original request
    return next.handle(request);
  }

  getToken(): string | null {
    return this.storageService.get(TOKEN_KEY)!;
  }

  private addAuthorizationHeader(
    request: HttpRequest<unknown>,
    token: string
  ): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private isJWTValid(): boolean {
    try {
      this.jwtHelperService.decodeToken(this.getToken()!);
      return true;
    } catch (e) {
      this.storageService.clear().subscribe();
      this.router.navigate(['/auth/login']);
      return false;
    }
  }

  private isJWTExpired(): boolean {
    const isExpired = this.jwtHelperService.isTokenExpired(this.getToken());

    if (isExpired) {
      this.storageService.clear().subscribe();
      this.router.navigate(['/auth/login']);
      return true;
    }

    return false;
  }
}
